import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
// import { bindInViewTimelineStagger } from '../util/animations'

class ProductCategoryMore {
  constructor ($el, masterTimeline) {
    this.$el = $el
    this.timelineHover = new TimelineMax({ paused: true })
    this.buildTimelineHover()

    $el.hover(
      () => { this.timelineHover.play() },
      () => { this.timelineHover.reverse() }
    )
  }

  buildTimelineHover () {
    const $el = this.$el
    this.timelineHover
      .to(
        $el,
        0.4,
        { backgroundColor: 'rgba(167, 138, 96, 0.85)', ease: Power0.easeNone }
      )
      .fromTo(
        $el.find('.v-line'),
        0.4,
        { scaleY: 1 },
        { scaleY: 0.4, ease: Power3.easeInOut },
        0
      )
      .to(
        $el.find('.explore'),
        0.4,
        { y: '-30px', ease: Power3.easeInOut },
        0
      )
      .to(
        $el.find('.explore'),
        0.2,
        { autoAlpha: 1, ease: Power0.easeNone },
        0.2
      )
  }
}

export default ProductCategoryMore



// WEBPACK FOOTER //
// ./scripts/components/ProductCategoryMore.js